import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ApiRequest from "../../../helper/ApiRequest";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import DataTable from "../../../component/DataTable";
import AddTmsIntegrationCategory from "./AddTmsIntegrationCategory";
import EditTmsIntegrationCategory from "./EditTmsIntegrationCategory";
import { toast } from "react-toastify";
import AdminHeader from "../../../component/AdminHeader";

const categoryListEndpoint = ApiEndpoints.tmsIntegrationCategory.categoryList;
const categoryDeleteEndpoint = ApiEndpoints.tmsIntegrationCategory.categoryDelete;
const tableHeader = ["Date", "Name", "Status"];
const tbody = ["createdAt", "name", "status"];

export default function TmsIntegrationCategory() {
  const [catId, setCatId] = useState("");
  const [modaleditShow, setModalEditShow] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", categoryListEndpoint);
      setData(response?.tms_integration_categories || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (tmsintegrationcategory_id) => {
    try {
      const response = await ApiRequest("POST", categoryDeleteEndpoint, { tmsintegrationcategory_id });
      response.error ? toast.error(response.message) : toast.success(response.message);
      dataFetch();
    } catch (error) {
      console.log(error);
    }
  };

  const pagename = {
    name: "TMS Integration",
    user: "Admin",
    innerpage: "TMS Integration / Category"
  };

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-btn-section">
        <Link className="admin-add-btn" onClick={() => setModalShow(true)}>Add +</Link>
        <DataTable data={data} tableHeader={tableHeader} tbody={tbody} setModalShow={setModalEditShow} setId={setCatId} onDelete={handleDelete} />
      </div>
      <AddTmsIntegrationCategory show={modalShow} onHide={() => { setModalShow(false); dataFetch(); }} />
      <EditTmsIntegrationCategory show={modaleditShow} catId={catId} onHide={() => { setModalEditShow(false); dataFetch(); }} />
    </>
  );
}
